"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUserProfileSchema = void 0;
exports.defaultUserProfileSchema = {
    type: "object",
    properties: {
        firstName: {
            type: "string",
            minLength: 2,
            title: "@@user.profile.firstname"
        },
        lastName: {
            type: "string",
            minLength: 2,
            title: "@@user.profile.lastname"
        }
    },
    additionalProperties: true
};
